import { useParams, Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.category === slug);

  if (!category) {
    return (
      <>
        <ScrollToTop />
        <Navbar />
        <div className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground-950 mb-4">分类未找到</h1>
            <Link to="/" className="text-primary-600 hover:text-primary-700 cursor-pointer">返回首页</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const catColor = category.color === 'accent' ? 'accent' : category.color === 'primary' ? 'primary' : 'secondary';

  return (
    <>
      <SEOHead
        title={category.name}
        description={`${category.description}。捆绑调教完全指南提供系统性的${category.name}内容，帮助成人伴侣安全探索捆绑调教。`}
        keywords={`捆绑调教,${category.name},捆绑调教技巧,捆绑调教道具,捆绑调教安全须知,BDSM捆绑指南`}
        canonicalUrl={`/category/${slug}`}
        jsonLdScripts={[
          {
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: `${category.name} - 捆绑调教完全指南`,
            description: category.description,
            url: `https://bondage-guide.com/category/${slug}`,
            isPartOf: { '@type': 'WebSite', name: '捆绑调教完全指南', url: 'https://bondage-guide.com' },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://bondage-guide.com/' },
              { '@type': 'ListItem', position: 2, name: category.name, item: `https://bondage-guide.com/category/${slug}` },
            ],
          },
        ]}
      />
      <ScrollToTop />
      <Navbar />
      <main className="pt-24 pb-16 bg-background-50 min-h-screen">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: category.name },
            ]}
          />

          <div className="mb-10">
            <div className="flex items-center gap-4 mb-4">
              <div className={`w-14 h-14 flex items-center justify-center rounded-xl bg-${catColor}-100 text-${catColor}-700`}>
                <i className={`${category.icon} text-2xl`}></i>
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-bold text-foreground-950">{category.name}</h1>
                <p className="text-sm text-foreground-600 mt-1">{category.description}</p>
              </div>
            </div>
          </div>

          <div className="mb-8">
            <div className="flex flex-wrap gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-700 hover:bg-background-200/70'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {categoryArticles.map((article) => (
                <ArticleCard
                  key={article.slug}
                  slug={article.slug}
                  title={article.title}
                  excerpt={article.excerpt}
                  category={article.category}
                  date={article.date}
                  readTime={article.readTime}
                  image={article.image}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <p className="text-foreground-500">该分类下暂无文章</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}